import 'core-js/stable'
import 'regenerator-runtime/runtime'
import moment from 'moment'
import Raven from 'raven-js'
import './boot.js'
import { loadApplication } from './loadApp'

global.moment = moment

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('service-worker.js')
}

if (__RAVEN__) {
  Raven
    .config('https://9dae960386dc4f0bb21f87914c568331@sentry.vptech.eu/144', {
      release: __VERSION__
    })
    .install()
}

if (__RAVEN__) {
  Raven.context(loadApplication)
} else {
  loadApplication()
}
